export const SIGNUP_INIT_ACTION = "SIGNUP_INIT";

export const FETCH_SIGNUP_SUCCESS_ACTION = SIGNUP_INIT_ACTION + "_SUCCESS";
export const FETCH_SIGNUP_FAIL_ACTION = SIGNUP_INIT_ACTION + "_ERROR";

export const SENDOTP_SUCCESS_ACTION = SIGNUP_INIT_ACTION + "SENDOTP_SUCCESS";
export const SENDOTP_FAIL_ACTION = SIGNUP_INIT_ACTION + "SENDOTP_ERROR";

export const FETCH_TnC_INIT_ACTION = "FETCH_TnC_INIT_ACTION";
export const FETCH_TnC_SUCCESS_ACTION = FETCH_TnC_INIT_ACTION +"_SUCCESS";
export const FETCH_TnC_ERROR_ACTION = FETCH_TnC_INIT_ACTION + "_ERROR"

export function signup(cred) {
  return {
    type: SIGNUP_INIT_ACTION,
    cred: cred
  };
}

export function fetchtandc(){
  return {
    type:FETCH_TnC_INIT_ACTION
  }
}
